import React from 'react';
import './CV.css';

function CV() {
  return (
    <div className="cv-container">
      <header className="cv-header">
        <h1 className="cv-title">UX Designer / UX Researcher / UI Designer / Graphic Designer</h1>
      </header>

      <div className="cv-left">
        <section className="cv-section">
          <h2 className="cv-section-title">Experience</h2>

          <div className="cv-job">
            <div className="cv-job-title">Freelance UX/UI Designer — Self-Employed</div>
            <div className="cv-job-date">01/2025 -</div>
            <ul className="cv-job-description">
              <li>Designing websites and e-commerce (UX/UI, information architecture, responsive design)</li>
              <li>Creating analytical dashboards and data-driven user interfaces</li>
              <li>Developing wireframes and high-fidelity prototypes in Figma</li>
              <li>Collaborating with clients and iterating designs based on feedback and usability principles</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">Siemens Digital Logistics, Wroclaw — UX/UI Designer</div>
            <div className="cv-job-date">June 2019 - Jan 2025</div>
            <ul className="cv-job-description">
              <li>Identified UX issues in Logistics SaaS platforms and proposed design improvements</li>
              <li>Redesigned mobile & desktop interfaces, improving usability and efficiency</li>
              <li>Conducted UX research to optimize workflows and enhance user interactions</li>
              <li>Developed scalable UI components and maintained design systems for consistency</li>
              <li>Integrated user insights into product strategy and UX decisions</li>
              <li>Created interactive prototypes in Figma, streamlining user flows and interactions</li>
              <li>Enhanced platform tools & solutions for engineers, ensuring seamless collaboration</li>
              <li>Ensured design consistency through UI documentation and standardization</li>
              <li>Worked cross-functionally with engineers & product teams to implement scalable UX solutions</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">OK - Interactive, Gdansk — Graphic Designer/UI</div>
            <div className="cv-job-date">Sep 2016 - Jul 2019</div>
            <ul className="cv-job-description">
              <li>Designed responsive websites, landing pages, and web applications for various industries</li>
              <li>Developed UI kits & reusable design components to maintain brand consistency</li>
              <li>Created interactive UI elements and micro-interactions to enhance engagement</li>
              <li>Optimized mobile-first designs, ensuring smooth cross-device experiences</li>
              <li>Worked with Adobe Creative Suite and WordPress to deliver end-to-end digital solutions</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">Panorama, Gdansk — Illustrator/Graphic Designer</div>
            <div className="cv-job-date">June 2011 - June 2019</div>
            <ul className="cv-job-description">
              <li>Specialized in print media, designing posters and postcards</li>
              <li>Performed color corrections & photo editing, improving quality for high-standard print production</li>
              <li>Created illustrations and developed vector illustrations, decorative elements</li>
              <li>Designed decorative paper & packaging, creating custom textures and patterns</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">Freelance Designer — Self-Employed</div>
            <div className="cv-job-date">June 2011 - June 2019</div>
            <ul className="cv-job-description">
              <li>Designed websites, landing pages, and mobile interfaces, focusing on usability and accessibility</li>
              <li>Created branding assets, UI kits, and marketing visuals for start-ups and businesses</li>
              <li>Developed custom illustrations & vector graphics for digital and print projects</li>
              <li>Worked closely with clients and engineers, ensuring smooth design-to-development implementation</li>
            </ul>
          </div>
        </section>
      </div>

      <div className="cv-right">
        <section className="cv-section">
          <h2 className="cv-section-title">Education</h2>

          <div className="cv-education-entry">
            <div className="cv-education-title">Academy of Fine Arts, Gdansk</div>
            <div className="cv-education-institution">Bachelor's degree</div>
            <div className="cv-education-detail">Oct 2007 - Oct 2011</div>
          </div>

          <div className="cv-education-entry">
            <div className="cv-education-title">Art</div>
            <div className="cv-education-institution">Nicolaus Copernicus University, Torun</div>
            <div className="cv-education-institution">Bachelor's degree</div>
            <div className="cv-education-detail">Oct 2006 - Jun 2011</div>
            <div className="cv-education-detail">Intermedia, Erasmus scholarship in Finland</div>
          </div>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Summary</h2>

          <div className="cv-summary">
            <p>UX/UI Designer | Graphic Designer</p>
            <p>with <span className="cv-summary-highlight">10+ years</span> of experience, including <span className="cv-summary-highlight">over 5 years</span> at <span className="cv-summary-highlight">Siemens Digital Logistics</span> working on Logistics (SaaS solutions).</p>

            <p>Specialized in improving <span className="cv-summary-highlight">usability, identifying UX issues, and implementing</span> scalable design systems.</p>

            <p>Skilled in <span className="cv-summary-highlight">wireframing, prototyping, and UX research, integrating user insights into product strategy</span>.</p>

            <p>Strong <span className="cv-summary-highlight">collaborator with product managers, engineers, and stakeholders</span>, driving data-driven, user-friendly solutions.</p>
          </div>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Skills</h2>

          <div className="cv-skills-list">
            Interface Design | UX Research | Wireframing | Animation | Agile
          </div>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Tools</h2>

          <ul className="cv-tools-list">
            <li>Figma</li>
            <li>Adobe Creative Suite (Photoshop, Illustrator, InDesign)</li>
            <li>Confluence</li>
            <li>Jira</li>
          </ul>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Trainings</h2>

          <ul className="cv-trainings-list">
            <li>
              <span className="cv-training-name">SAFe Training:</span> <span className="cv-training-date">Oct 2024</span>
            </li>
            <li>
              <span className="cv-training-name">Designing For Complex UI</span> <span className="cv-training-date">Feb 2022</span>
              <div className="cv-training-instructor">(Workshop by Vitaly Friedman)</div>
            </li>
            <li>
              <span className="cv-training-name">Figma course</span> <span className="cv-training-date">Nov 2021</span>
            </li>
            <li>
              <span className="cv-training-name">(Udemy)</span>
            </li>
            <li>
              <span className="cv-training-name">UX design course</span> <span className="cv-training-date">Oct 2020 - Feb 2021</span>
            </li>
            <li>
              <span className="cv-training-name">(Infoshare Academy)</span>
            </li>
          </ul>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Languages</h2>

          <div className="cv-language">
            <span className="cv-language-name">English:</span> Fluent
          </div>
          <div className="cv-language">
            <span className="cv-language-name">Polish:</span> Native
          </div>
        </section>
      </div>
    </div>
  );
}

export default CV;